/** @jsx jsx */
import { jsx, Button, Divider, Flex, Text } from 'theme-ui'
import {
  defaultDistribionLink,
  FormModal as ResourceModalButton,
  GET_DISTRIBION_DATA_TO_POST,
} from '../../utils/getDistribionLink'
import { any, string } from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'

const DistribionLink = ({ title, text, url, ...props }) => {
  const [distribionData, setDistribionData] = useState(null)
  const [distribionFormVisible, setDistribionFormVisible] = useState(false)
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [getDistribionData, { data }] = useLazyQuery(
    GET_DISTRIBION_DATA_TO_POST,
    {
      variables: {
        distribionResourceUrl:
          url && url.toLowerCase().includes('https://studiotoolkit')
            ? url
            : defaultDistribionLink,
      },
      fetchPolicy: 'no-cache',
    }
  )
  useEffect(() => {
    if (data?.distribionSamlResponse) {
      setDistribionData(data)
    }
  }, [data])
  return url ? (
    <React.Fragment>
      <Button
        sx={{
          backgroundColor: 'transparent',
          fontSize: '14px',
          fontWeight: '400',
          fontFamily: 'body',
          textAlign: 'left',
          padding: 0,
          margin: 0,
          ':hover': { cursor: 'pointer' },
        }}
        onClick={getDistribionData}
        {...props}
      >
        <Text variant="h6" sx={{ color: 'black' }}>
          {title}
        </Text>
        <Flex sx={{ flexDirection: 'column' }}>
          <Divider sx={{ width: '100%', my: 4 }} />
          <Text variant="xSmallText" color="darkGray">
            {text}
          </Text>
        </Flex>
      </Button>
      {distribionData && (
        <ResourceModalButton
          formSubmitted={formSubmitted}
          setFormSubmitted={setFormSubmitted}
          distribionFormVisible={distribionFormVisible}
          setDistribionFormVisible={setDistribionFormVisible}
          data={distribionData}
        />
      )}
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Button
        sx={{
          color: 'white',
          backgroundColor: 'transparent',
          padding: 0,
          margin: 0,
          textAlign: 'left',
          fontWeight: 'normal',
          fontFamily: 'heading',
          ':hover': { cursor: 'pointer' },
        }}
        onClick={getDistribionData}
        {...props}
      >
        <span>{text}</span>
      </Button>
      {distribionData && (
        <ResourceModalButton
          formSubmitted={formSubmitted}
          setFormSubmitted={setFormSubmitted}
          distribionFormVisible={distribionFormVisible}
          setDistribionFormVisible={setDistribionFormVisible}
          data={distribionData}
        />
      )}
    </React.Fragment>
  )
}
DistribionLink.propTypes = {
  title: string,
  text: any.isRequired,
  url: string,
}

export default DistribionLink
